import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, ReactiveFormsModule, ValidationErrors } from "@angular/forms";
import { getLocaleDateString } from "@ankaadia/ankaadia-shared";
import { TranslocoService } from "@jsverse/transloco";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Calendar as OldCalendar } from "primeng-v17/calendar";
import { Message } from "primeng/message";
import { environment } from "../../../environments/environment";
import { NewUiDatepickerComponent } from "../../shared/form/datepicker/new-ui-datepicker.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-datepicker",
  templateUrl: "./new-ui-formly-datepicker.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiDatepickerComponent,
    ReactiveFormsModule,
    FormlyModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
  ],
})
export class NewUiFormlyDatepickerComponent extends FieldType implements OnInit {
  readonly language = this.transloco.getActiveLang();

  @ViewChild(environment.newUI ? NewUiDatepickerComponent : OldCalendar)
  calendar: NewUiDatepickerComponent | OldCalendar;

  format: string;
  placeholder: string;
  protected currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  constructor(private readonly transloco: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.format = getLocaleDateString(this.language, this.props.timeOnly ? "hour" : this.props.view);
    this.placeholder = this.props.timeOnly
      ? "hh:mm"
      : this.props.view == null || this.props.view == "date"
        ? getLocaleDateString(this.language, "date_Placeholder")
        : this.format;
    if (this.props.required && this.props.selectionMode == "range") this.formControl.addValidators(this.validateRange);
  }

  reset(event: Event): void {
    this.calendar.onClearButtonClick(event);
  }

  private validateRange(control: FormControl): ValidationErrors | null {
    return control.value?.length == 2 && control.value.every((x) => x) ? null : { range: true };
  }
}
